import Layout from "../../components/layout/Layout";
import DatePicker from "react-datepicker";
import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
  getAttendanceList,
  processAttendanceList,
  saveUpdateAttendance,
} from "../../api/attendance";
import { EyeIcon, PencilAltIcon, XIcon } from "@heroicons/react/solid";
import { Modal } from "@mui/material";
import spinner from "../../assets/images/spinner.gif";
import ViewAttendanceDetail from "./ViewAttendanceDetail";
import Moment from "react-moment";
import moment from "moment";
import { HiDownload } from "react-icons/hi";
import useDownloadFile from "../../hooks/useDownloadFile";
import InlineLoader from "../../components/loader/InlineLoader";
import toast from "react-hot-toast";
import BreadCrumbs from "../../components/ui/BreadCrumbs";
import useGet from "../../hooks/read/useGet";
import { Button, Select } from "../../components/ui";
import RoundedContainer from "../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";

const processing_status = {
  1: {
    color: "bg-green-200 text-green-600",
    value: "Attendance Processed",
  },
  2: {
    color: "bg-yellow-200 text-yellow-600",
    value: "Attendance Processing",
  },
  3: {
    color: "bg-red-200 text-red-600",
    value: "Attendance Not Processed",
  },
};

const attendanceShift = {
  present: {
    color: "bg-green-200 text-green-600",
    value: "Present",
  },
  absent: {
    color: "bg-red-200 text-red-600",
    value: "Absent",
  },
  half_day: {
    color: "bg-lime-200 text-black",
    value: "Half Day",
  },
  weekend: {
    color: "bg-blue-200 text-blue-600",
    value: "Leave",
  },
  on_approved_leave: {
    color: "bg-blue-200 text-blue-600",
    value: "Leave",
  },
  under_process: {
    color: "bg-orange-200 text-orange-600",
    value: "Under Process",
  },
  missed_punch: {
    color: "bg-purple-200 text-purple-600",
    value: "Missed Punch",
  },
};
const IS_REQUIRED = true;

function ViewAttendance() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const employee_name = searchParams.get("employee_name");
  const breadcrumbs = [
    { label: "Attendance", link: "/attendance" },
    { label: `${employee_name}'s Attendance`, link: `` },
  ];
  let initialData = {
    month_and_year: new Date(),
    company_employee_id: id,
  };
  let initialAttendanceData = {
    date: new Date(),
    out_date: new Date(),
    in_time: new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    }),
    out_time: new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    }),
    company_employee_id: id,
    id: "",
    shift: "",
    status: "",
  };
  const [filterData, setFilterData] = useState(initialData);
  const [isFetching, setIsFetching] = useState(false);
  const [isDataFound, setDataFound] = useState(true);
  const [attendanceList, setAttendanceList] = useState([]);
  const [addAttendanceModal, setAddAttendanceModal] = useState(false);
  const [attendanceFormData, setAttendanceFormData] = useState(
    initialAttendanceData
  );
  const [isSaving, setIsSaving] = useState(false);
  const [attendanceEditModal, setEditAttendanceModal] = useState(false);
  const [singleAttendanceData, setSingleAttendanceData] = useState({});
  const [attendanceId, setAttendanceData] = useState("");
  const [isDateCalculated, setIsDateCalculated] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleError = async (err) => {
    if (err?.response?.data instanceof Blob) {
      const text = await err.response.data.text();
      try {
        const errorData = JSON.parse(text);
        toast.error(errorData.message || "Something went wrong");
      } catch (e) {
        toast.error("Something went wrong");
      }
    } else {
      toast.error(
        err?.response?.data?.message || err?.message || "Something went wrong"
      );
    }
  };

  const { reportDownload } = useDownloadFile({
    url: "employee_attendance_report",
    onError: handleError,
  });

  const handleDownloadReport = () => {
    const formattedDate = moment(filterData.month_and_year).format("MMM_YYYY");
    reportDownload.mutate({
      month_year: filterData.month_and_year,
      company_employee_id: id,
      external_filename: `Attendance_Report_${formattedDate}.xlsx`,
    });
  };
  const handleConfirmProcessAttendance = async () => {
    setIsModalOpen(false); // Close the modal

    let initialData = {
      month_and_year: filterData.month_and_year,
      company_employee_id: id,
    };

    let data = {
      ...initialData,
    };

    setFilterData(data);

    try {
      const response = await processAttendanceList(data);
      // Handle the response as needed
    } catch (error) {
      console.error("Error processing attendance:", error);
      // Handle the error as needed
    }
  };
  const handleDate = (value, name) => {
    let data = {
      ...filterData,
      [name]: value,
    };
    setFilterData(data);
  };
  const handleCalculateSalary = () => {
    setDataFound(true);
    setIsFetching(true);
    getAttendanceList(filterData)
      .then((res) => {
        if (res.status === 200) {
          setAttendanceList(res.data);
          if (res.data.length <= 0) {
            setDataFound(false);
          }
          setIsFetching(false);
          setIsDateCalculated(true);
        }
      })
      .catch((err) => {
        alert("Something went wrong!");
        setIsFetching(false);
      });
  };

  const handleHolidayFormInputs = (value) => {
    let data;
    if (value.isDateTime) {
      data = {
        ...attendanceFormData,
        [value.name]: value.value,
      };
    } else if (value.target.type === "checkbox") {
      data = {
        ...attendanceFormData,
        [value.target.name]: value.target.checked,
      };
    } else {
      let val = value.target.value;
      data = {
        ...attendanceFormData,
        [value.target.name]: val,
      };
    }
    setAttendanceFormData(data);
  };

  const handleCancelForm = () => {
    setAddAttendanceModal(false);
    setEditAttendanceModal(false);
    setAttendanceFormData(initialAttendanceData);
    setAttendanceData("");
  };
  const handleAddAttendance = () => {
    setAddAttendanceModal(true);
  };
  const handleSaveAttendance = (e, action) => {
    setIsSaving(true);
    e.preventDefault();

    const finalData = { ...attendanceFormData };

    if (finalData.date instanceof Date) {
      const d = finalData.date;
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      finalData.date = `${year}-${month}-${day}`;
    }

    if (finalData.date) {
      const parts = finalData.date.split("-");
      if (parts.length === 3) {
        finalData.attendance_year = parts[0];
        finalData.attendance_month = parseInt(parts[1], 10).toString(); // remove leading zeros
        finalData.attendance_date = parseInt(parts[2], 10).toString();
      }
    }

    if (finalData.out_date instanceof Date) {
      const d = finalData.out_date;
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      finalData.out_date = `${year}-${month}-${day}`;
    }

    if (finalData.out_date) {
      const parts = finalData.out_date.split("-");
      if (parts.length === 3) {
        finalData.attendance_out_year = parts[0];
        finalData.attendance_out_month = parseInt(parts[1], 10).toString();
        finalData.attendance_out_date = parseInt(parts[2], 10).toString();
      }
    }

    const selectedOption = leaveTypesOptions.find(
      (el) => el.value === finalData.redeem_leave_head_id
    );

    finalData.redeem_leave_head_name = selectedOption?.label;
    finalData.redeem_leave_count =
      finalData.present_definition === "half_day" ? 0.5 : 1;
    // finalData.redeem_leave = attendanceFormData.redeem_leave ? 1 : 0;

    saveUpdateAttendance(finalData, action, attendanceId)
      .then((res) => {
        if (res.status === 200) {
          setIsSaving(false);
          handleCancelForm();
          handleCalculateSalary();
          toast.success(
            res?.data?.message ||
              `Attendance ${action === "Update" ? "updated" : "saved"} successfully`
          );
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            "Something went wrong please try again later!"
        );
        setIsSaving(false);
      });
  };

  const handleGetSingleData = (id) => {
    setAttendanceData(id);
    setEditAttendanceModal(true);
    const data = attendanceList.find((data) => data.id === id);
    setSingleAttendanceData(data);
    setAttendanceFormData(data);
  };
  function tConvert(time) {
    if (!time || time === undefined) {
      return (time = "---");
    }
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
      time.splice(3, 1);
    }
    return time.join(""); // return adjusted time or original string
  }

  const handleMarkLate = (e) => {
    let checked = e.target.checked;
    setAttendanceFormData((prev) => {
      return {
        ...prev,
        late: checked,
      };
    });
  };
  const [isViewAttendanceDrawerShow, setIsViewAttendanceDrawerShow] =
    useState(false);
  const handleOpenAttendanceDrawer = (id) => {
    setIsViewAttendanceDrawerShow(true);
    setAttendanceData(id);
  };

  // Code for redeem leave in edit attendance
  const { list, setGetListParams } = useGet({
    url: "settings/leave/list",
    initialData: {
      // company_id: companyId,
    },
  });

  const leaveTypesOptions = list?.data?.data?.map?.((el) => {
    return {
      label: el.leave_head_name,
      value: el.leave_head_id,
    };
  });

  return (
    <div className="pt-5">
      <div className="px-4 mb-20">
        <BreadCrumbs crumbs={breadcrumbs} />
        <form>
          <div className="flex space-x-4 items-end">
            <div className="flex space-x-4 items-end flex-1">
              <div className=" basis-[25%]">
                <label className=" roboto p-2 label">Select Month/Year</label>
                <DatePicker
                  required
                  name="month_and_year"
                  autoComplete="false"
                  className="input"
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  selected={filterData?.month_and_year}
                  onChange={(value) => handleDate(value, "month_and_year")}
                />
              </div>
              <div>
                <Button type="button" onClick={handleCalculateSalary}>
                  Fetch Attendance
                </Button>
              </div>
              <Button type="button" onClick={handleOpenModal}>
                Reprocess Attendance
              </Button>
              <Button
                type="button"
                onClick={handleDownloadReport}
                disabled={reportDownload.isLoading || !filterData.month_and_year}
              >
                {reportDownload.isLoading ? (
                  <>
                    <InlineLoader className="text-white mr-2 h-4 w-4" />
                    Downloading...
                  </>
                ) : (
                  <div className="flex items-center">
                    <HiDownload className="mr-2 h-4 w-4" />
                    Download Attendance
                  </div>
                )}
              </Button>
            </div>

            {isDateCalculated && (
              <div>
                <Button type="button" onClick={handleAddAttendance}>
                  Add Attendance
                </Button>
              </div>
            )}
          </div>

          {isModalOpen && (
            <div className="fixed inset-0 flex items-center justify-center z-[60] bg-black bg-opacity-50">
              <div className="bg-white rounded-lg p-4">
                <p>Do you want to reprocess attendance?</p>
                <div className="mt-4">
                  <Button
                    variant={"success"}
                    className={"mr-2"}
                    onClick={handleConfirmProcessAttendance}
                  >
                    Yes
                  </Button>
                  <Button variant={"destructive"} onClick={handleCloseModal}>
                    No
                  </Button>
                </div>
              </div>
            </div>
          )}
        </form>
        {isFetching ? (
          <div className=" w-12 h-12 mx-auto mt-12">
            <img src={spinner} alt="spinner" className="w-full h-full" />
          </div>
        ) : (
          <RoundedContainer className="mt-8">
            <Table className="table-auto w-full">
              <TableHead>
                <TableHeaderCell className="min-w-[60px] font-semibold text-center">
                  Sr.No
                </TableHeaderCell>
                <TableHeaderCell className="min-w-[100px] font-semibold">
                  Day
                </TableHeaderCell>
                <TableHeaderCell className="min-w-[100px] font-semibold">
                  In Date
                </TableHeaderCell>
                <TableHeaderCell className="min-w-[100px] font-semibold">
                  In Time
                </TableHeaderCell>
                <TableHeaderCell className="min-w-[100px] font-semibold">
                  Out Date
                </TableHeaderCell>
                <TableHeaderCell className="min-w-[100px] font-semibold">
                  Out Time
                </TableHeaderCell>
                <TableHeaderCell className="min-w-[130px] font-semibold text-center">
                  Attendance
                </TableHeaderCell>
                <TableHeaderCell className="min-w-[130px] font-semibold text-center">
                  Leave Redeemed
                </TableHeaderCell>
                <TableHeaderCell className="min-w-[80px] font-semibold text-center">
                  Action
                </TableHeaderCell>
              </TableHead>
              {!isDataFound ? (
                <TableRow>
                  <TableCell colSpan={9}>
                    <div className="text-center py-5 text-gray-700 text-3xl font-semibold">
                      Opps!!! No Data found
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                <TableBody>
                  {attendanceList?.map((data, idx) => {
                    const {
                      attendance_date,
                      attendance_month,
                      attendance_year,
                      attendance_out_date,
                      attendance_out_month,
                      attendance_out_year,
                      in_time,
                      out_time,
                      shift,
                      id,
                      status,
                      date,
                      present_definition,
                      redeem_leave,
                    } = data;
                    return (
                      <TableRow key={idx}>
                        <TableCell className="text-center font-medium text-sm">
                          {idx + 1}
                        </TableCell>
                        <TableCell className="font-medium text-sm">
                          <Moment date={date} format="dddd" />
                        </TableCell>
                        <TableCell className="font-medium text-sm">{`${attendance_date}/${attendance_month}/${attendance_year}`}</TableCell>
                        <TableCell className="font-medium text-sm">
                          {tConvert(in_time)}
                        </TableCell>
                        <TableCell className="font-medium text-sm">
                          {attendance_out_date
                            ? `${attendance_out_date}/${attendance_out_month}/${attendance_out_year}`
                            : "---"}
                        </TableCell>
                        <TableCell className="font-medium text-sm">
                          {tConvert(out_time)}
                        </TableCell>
                        <TableCell className="text-center font-medium text-sm">
                          {/* {attendanceShift[present_definition]?.value} */}
                          <span
                            className={`${attendanceShift[present_definition]?.color} px-4 py-1 rounded-full text-sm`}
                          >
                            {attendanceShift[present_definition]?.value}
                          </span>
                          {/* {status === 'P' ? <span className="text-sm text-orange-700 bg-orange-200 px-4 py-1 rounded-full">Present</span> : <span className="text-sm text-red-700 bg-red-200 px-4 py-1 rounded-full">Absent</span>} */}
                        </TableCell>
                        <TableCell className="text-center font-medium text-sm">
                          {redeem_leave ? "Yes" : "No"}
                        </TableCell>
                        <TableCell className="font-medium text-sm">
                          <div className="flex items-center justify-center space-x-4">
                            <div
                              className="cursor-pointer w-6"
                              onClick={() => handleOpenAttendanceDrawer(id)}
                            >
                              <EyeIcon className=" text-gray-600 w-full  hover:text-blue-600" />
                            </div>
                            <div
                              className="cursor-pointer w-6"
                              onClick={() => handleGetSingleData(id)}
                            >
                              <PencilAltIcon className=" text-gray-600 w-full  hover:text-blue-600" />
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              )}
            </Table>
          </RoundedContainer>
        )}
      </div>
      <Modal
        open={addAttendanceModal}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
      >
        <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[20%]">
          <div className="document-wrapper px-4 divide-y">
            <div className="document-head py-4">
              <div className="flex items-center justify-between">
                <h3 className=" text-gray-700 text-3xl font-semibold">
                  Add Attendance
                </h3>
                <div
                  className=" w-6 h-6 cursor-pointer"
                  onClick={handleCancelForm}
                >
                  <XIcon className=" text-black w-full h-full" />
                </div>
              </div>
            </div>
            <div className="document-body max-h-96 overflow-auto">
              <form
                method="post "
                className="divide-y"
                onSubmit={(e) => handleSaveAttendance(e, "Save")}
              >
                <div className="grid grid-cols-2 gap-4 py-4">
                  <div className="">
                    <label htmlFor="holiday_name" className="label">
                      In Date:<span className="mandatory">*</span>
                    </label>
                    <DatePicker
                      selected={attendanceFormData.date}
                      name="date"
                      onChange={(value) =>
                        handleHolidayFormInputs({
                          value,
                          name: "date",
                          isDateTime: true,
                        })
                      }
                      className="input"
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                  <div className="">
                    <label htmlFor="holiday_name" className="label">
                      Out Date:<span className="mandatory">*</span>
                    </label>
                    <DatePicker
                      selected={attendanceFormData.out_date}
                      name="out_date"
                      onChange={(value) =>
                        handleHolidayFormInputs({
                          value,
                          name: "out_date",
                          isDateTime: true,
                        })
                      }
                      className="input"
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                  <div className="">
                    <label htmlFor="in_time" className="label">
                      In Time:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="time"
                      name="in_time"
                      value={attendanceFormData.in_time}
                      className="input"
                      onChange={(e) => handleHolidayFormInputs(e)}
                    />
                  </div>
                  <div className="">
                    <label htmlFor="out_time" className="label">
                      Out Time:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="time"
                      name="out_time"
                      value={attendanceFormData.out_time}
                      className="input"
                      onChange={(e) => handleHolidayFormInputs(e)}
                    />
                  </div>
                  {/* <div className="">
                                        <label htmlFor="shift" className='label'>Shift:<span className='mandatory'>*</span></label>
                                        <input type="text" name='shift' className='input' required={IS_REQUIRED} value={attendanceFormData.shift} onChange={(e) => handleHolidayFormInputs(e)} placeholder='Shift' />
                                    </div> */}
                  <div className="">
                    <label htmlFor="status" className="label">
                      Status:<span className="mandatory">*</span>
                    </label>
                    <select
                      className="input"
                      name="status"
                      required={IS_REQUIRED}
                      value={attendanceFormData.status}
                      onChange={(e) => handleHolidayFormInputs(e)}
                    >
                      <option value="">--Select Attendance--</option>
                      <option value="P">Present</option>
                      <option value="A">Absent</option>
                    </select>
                  </div>
                </div>
                <div className="document-foot space-x-4 py-4">
                  {isSaving ? (
                    <div className=" w-8 h-8 mx-auto">
                      <img
                        src={spinner}
                        alt="spinner"
                        className="w-full h-full"
                      />
                    </div>
                  ) : (
                    <div className="text-center space-x-4">
                      <Button type="submit">Save</Button>
                      <Button
                        type="button"
                        variant={"outline"}
                        onClick={handleCancelForm}
                      >
                        Cancel
                      </Button>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        open={attendanceEditModal}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
      >
        <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[1%]">
          <div className="document-wrapper px-4 divide-y">
            <div className="document-head py-4">
              <div className="flex items-center justify-between">
                <h3 className=" text-gray-700 text-3xl font-semibold">
                  Edit Attendance
                  <span
                    className={` px-4 py-1 font-semibold rounded-md ${processing_status[attendanceFormData?.processing_status]
                      ?.color
                      }`}
                  >
                    {
                      processing_status[attendanceFormData?.processing_status]
                        ?.value
                    }
                  </span>
                </h3>
                <div
                  className=" w-6 h-6 cursor-pointer"
                  onClick={handleCancelForm}
                >
                  <XIcon className=" text-black w-full h-full" />
                </div>
              </div>
            </div>
            <div className="document-body max-h-[34rem] overflow-auto">
              <form
                method="post "
                className="divide-y"
                onSubmit={(e) => handleSaveAttendance(e, "Update")}
              >
                <div className="grid grid-cols-2 gap-4 py-4">
                  <div className="">
                    <label htmlFor="holiday_name" className="label">
                      In Date:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="date"
                      name="date"
                      value={attendanceFormData.date || ""}
                      className="input"
                      onChange={(e) => handleHolidayFormInputs(e)}
                    />
                  </div>
                  <div className="">
                    <label htmlFor="holiday_name" className="label">
                      Out Date:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="date"
                      name="out_date"
                      value={attendanceFormData.out_date || ""}
                      className="input"
                      onChange={(e) => handleHolidayFormInputs(e)}
                    />
                  </div>
                  <div className="">
                    <label htmlFor="in_time" className="label">
                      In Time:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="time"
                      name="in_time"
                      value={attendanceFormData.in_time}
                      className="input"
                      onChange={(e) => handleHolidayFormInputs(e)}
                    />
                  </div>
                  <div className="">
                    <label htmlFor="out_time" className="label">
                      Out Time:<span className="mandatory">*</span>
                    </label>
                    <input
                      type="time"
                      name="out_time"
                      value={attendanceFormData.out_time}
                      className="input"
                      onChange={(e) => handleHolidayFormInputs(e)}
                    />
                  </div>
                  {/* <div className="">
                                        <label htmlFor="shift" className='label'>Shift:<span className='mandatory'>*</span></label>
                                        <input type="text" name='shift' className='input' required={IS_REQUIRED} value={attendanceFormData.shift} onChange={(e) => handleHolidayFormInputs(e)} placeholder='Shift' />
                                    </div> */}
                  <div className="">
                    <label htmlFor="status" className="label">
                      Status:<span className="mandatory">*</span>
                    </label>
                    <select
                      className="input"
                      name="status"
                      required={IS_REQUIRED}
                      value={attendanceFormData.status}
                      onChange={(e) => handleHolidayFormInputs(e)}
                    >
                      <option value="">--Select Attendance--</option>
                      <option value="P">Present</option>
                      <option value="A">Absent</option>
                    </select>
                  </div>
                  <div className="">
                    <label htmlFor="status" className="label">
                      Present Definition:
                    </label>
                    <p className="input">
                      {attendanceFormData?.present_definition || "---"}
                    </p>
                  </div>
                  <div className="">
                    <div>
                      <label htmlFor="out_time" className="label">
                        Late Duration
                      </label>
                      <p className="input">
                        {attendanceFormData?.late_duration || "---"}
                      </p>
                    </div>
                    <div className="mt-2">
                      <label className=" space-x-2">
                        <input
                          type="checkbox"
                          name=""
                          id=""
                          checked={attendanceFormData?.late}
                          onChange={handleMarkLate}
                        />
                        <span>Mark Late</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-span-2 flex items-start space-x-4">
                    <div>
                      <input
                        type="checkbox"
                        className="mr-3"
                        name="redeem_leave"
                        checked={attendanceFormData.redeem_leave}
                        id="should-redeem-leave"
                        onChange={(e) => handleHolidayFormInputs(e)}
                      />
                      <label htmlFor="should-redeem-leave">Redeem Leave?</label>
                    </div>

                    {attendanceFormData.redeem_leave && (
                      <div className="flex items-start space-x-8">
                        <div>
                          <label htmlFor="">Leave type:</label>
                          <select
                            className="input"
                            name="redeem_leave_head_id"
                            value={attendanceFormData.redeem_leave_head_id}
                            onChange={(e) => handleHolidayFormInputs(e)}
                          >
                            <option value="">--Select Leave Type--</option>
                            {leaveTypesOptions?.map((option, idx) => {
                              return (
                                <option key={idx} value={option.value}>
                                  {option.label}
                                </option>
                              );
                            })}
                          </select>
                        </div>

                        <p className="text-center">
                          <span>Leave count:</span>
                          <br />
                          <span className="mt-1 block">
                            {attendanceFormData?.present_definition ===
                              "half_day"
                              ? "0.5"
                              : "1"}
                          </span>
                        </p>
                      </div>
                    )}
                  </div>

                  <div>
                    <label htmlFor="out_time" className="label">
                      Total Working Hours
                    </label>
                    {
                      <p className="input">
                        {attendanceFormData?.total_worked_hours || "---"}
                      </p>
                    }
                  </div>
                </div>
                <div className="document-foot space-x-4 py-4">
                  {isSaving ? (
                    <div className=" w-8 h-8 mx-auto">
                      <img
                        src={spinner}
                        alt="spinner"
                        className="w-full h-full"
                      />
                    </div>
                  ) : (
                    <div className="text-center space-x-4">
                      <Button type="submit">Update</Button>
                      <Button
                        type="button"
                        variant={"outline"}
                        onClick={handleCancelForm}
                      >
                        Cancel
                      </Button>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
      <ViewAttendanceDetail
        id={attendanceId}
        onClose={() => setIsViewAttendanceDrawerShow(false)}
        open={isViewAttendanceDrawerShow}
      />
    </div>
  );
}

export default ViewAttendance;
